import { UtmifyTrackingParameters } from '../types/utmify-event';

const STORAGE_KEY = 'vendepay:utmify-tracking-parameters';

type StoredTrackingParameters = Record<string, UtmifyTrackingParameters>;

const emptyTrackingParameters = (): UtmifyTrackingParameters => ({
  src: null,
  sck: null,
  utm_source: null,
  utm_campaign: null,
  utm_medium: null,
  utm_content: null,
  utm_term: null,
});

const readStoredTrackingParameters = (
  vendaId: string,
): Partial<UtmifyTrackingParameters> => {
  if (typeof window === 'undefined') {
    return {};
  }

  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return {};
    }

    const parsed = JSON.parse(raw) as StoredTrackingParameters;
    if (typeof parsed !== 'object' || parsed === null) {
      return {};
    }

    return parsed[vendaId] ?? {};
  } catch {
    return {};
  }
};

const persistTrackingParameters = (
  vendaId: string,
  parameters: UtmifyTrackingParameters,
) => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    const parsed = raw ? (JSON.parse(raw) as StoredTrackingParameters) : {};
    const current =
      typeof parsed === 'object' && parsed !== null ? parsed : {};

    window.sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        ...current,
        [vendaId]: parameters,
      }),
    );
  } catch {
    // Ignora falhas de storage para não bloquear o tracking.
  }
};

export const getUtmifyTrackingParameters = (
  vendaId: string,
): UtmifyTrackingParameters => {
  if (typeof window === 'undefined') {
    return emptyTrackingParameters();
  }

  const params = new URLSearchParams(window.location.search);
  const stored = readStoredTrackingParameters(vendaId);

  const resolved: UtmifyTrackingParameters = {
    src: params.get('src') ?? stored.src ?? null,
    sck: params.get('sck') ?? stored.sck ?? null,
    utm_source: params.get('utm_source') ?? stored.utm_source ?? null,
    utm_campaign: params.get('utm_campaign') ?? stored.utm_campaign ?? null,
    utm_medium: params.get('utm_medium') ?? stored.utm_medium ?? null,
    utm_content: params.get('utm_content') ?? stored.utm_content ?? null,
    utm_term: params.get('utm_term') ?? stored.utm_term ?? null,
  };

  persistTrackingParameters(vendaId, resolved);
  return resolved;
};
